import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { AcquisitionTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';


@Component({
  selector: 'cradua-acquisitiontype-container',
  templateUrl: './acquisitiontype-container.component.html',
  styleUrls: ['./acquisitiontype-container.component.scss']
})
export class AcquisitiontypeContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  acquisitiontypes$: Observable<AcquisitionTypeDto[]>;
  loading: boolean;
  isLoadingAcquisitionType$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingAcquisitionType$ = this.gatwayFacade.isLoadingGateway('AcquisitionType');
    this.acquisitiontypes$ = this.gatwayFacade.loadGateway('AcquisitionType');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteAcquisitionType(deletedValue: any) {
    this.gatwayFacade.remove('AcquisitionType', deletedValue);
  }

  // this method control both the create and update

  onSubmitAcquisitionType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.AcquisitionTypes;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllAcquisitionType = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllAcquisitionType.push(pullData[i]);
      }
    }

    // check if the addAllAcquisitionType array is not empty, then dispatch the data to the store
    if (addAllAcquisitionType.length > 0) {
      this.gatwayFacade.add('AcquisitionType', addAllAcquisitionType);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('AcquisitionType', allUpdates, ['id']);
    }
  }
}
